import { render, staticRenderFns } from "./AccessibilityStatement.vue?vue&type=template&id=23374e16&"
import script from "./AccessibilityStatement.vue?vue&type=script&lang=js&"
export * from "./AccessibilityStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports